import { createAction, props } from "@ngrx/store";
import { PersistentNotification } from "./persistent-notification.model";

export const loadPersistentNotifications = createAction(
  "[PersistentNotification] Load PersistentNotifications",
);

export const loadPersistentNotificationsSuccess = createAction(
  "[PersistentNotification] Load PersistentNotifications Success",
  props<{ notifications: PersistentNotification[] }>(),
);

export const loadPersistentNotificationsFailure = createAction(
  "[PersistentNotification] Load PersistentNotifications Failure",
  props<{ error: any }>(),
);

export const addPersistentNotification = createAction(
  "[PersistentNotification] Add PersistentNotification",
  props<{ notification: PersistentNotification }>(),
);

export const markAllPersistentNotificationViewed = createAction(
  "[PersistentNotification] Mark All PersistentNotifications Viewed",
);

export const markAllPersistentNotificationViewedSuccess = createAction(
  "[PersistentNotification] Mark All PersistentNotifications Viewed Success",
);
